// This is Greenhouse-only (for now)

import React from "react";
import parse from "html-react-parser";
import styled from "styled-components";

const Container = styled.div`
  visibility: visible;
  font-family: Inter;
  font-size: 14px;
  line-height: 17px;
  color: #242424;

  a {
    color: #002de4 !important;
    font-weight: 600 !important;
    text-decoration-line: underline !important;
  }
`;

const Description = ({ html }) => {
  if (!html) {
    return null;
  }

  return <Container>{parse(html)}</Container>;
};

export default Description;
